import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { canonicalRedirectUrl } from "@/lib/canonicalHost";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const redirectTo = canonicalRedirectUrl(window.location, process.env.REACT_APP_BACKEND_URL);
if (redirectTo) window.location.replace(redirectTo);

const root = ReactDOM.createRoot(document.getElementById("root"));
if (!redirectTo) root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
